"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ErrorScreen = function ErrorScreen(props) {
  var stateMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.messageReducer.errorMessage;
  });
  var message = props.message ? props.message : stateMessage;

  if (message === null || message === void 0 ? void 0 : message.fullScreen) {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: 'splash-screen-container'
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: 'splash-screen-message'
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'exclamation-triangle']
    }), /*#__PURE__*/_react.default.createElement("span", null, message === null || message === void 0 ? void 0 : message.message)));
  }

  return /*#__PURE__*/_react.default.createElement("div", null, "\xA0");
};

ErrorScreen.propTypes = {
  message: _propTypes.default.any
};
var _default = ErrorScreen;
exports.default = _default;